module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-10@3x__70a24584cdab33d2ccc217699b10cad2.png";